


























































import { Vue, Component, Prop } from "vue-property-decorator";
import { UserInfo } from "../../_models/userInfo";
import CardTitle from "../CardTitle.vue";
import DetailsInfo from "../Details/DetailsInfo.vue";
import EditDialog from "../Edit/EditDialog.vue";
import ChagePassword from "../ChangePassword.vue";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";

@Component({
  components: {
    CardTitle,
    DetailsInfo,
    EditDialog,
    ChagePassword
  }
})
export default class UserDetails extends Vue {
  @Prop()userInfo !: UserInfo;
  @Prop() checkComplete!: boolean;
  private titleParams: object;
  private userData: UserInfo;
  private ruolo: number[];
  private isComplete: boolean;

  constructor() {
    super();
    this.titleParams = {
      title: "Dati Personali",
      cols: "12",
      sm: "6",
      md: "5",
      lg: "4"
    };
    this.isComplete = false;
    this.userData = {
      tipoSoggetto: this.userInfo.tipoSoggetto,
      ruoloUtente: this.userInfo.ruoloUtente,
      descrizioneRuolo: this.userInfo.descrizioneRuolo,
      nomeUtente: this.userInfo.nomeUtente,
      cognomeUtente: this.userInfo.cognomeUtente,
      indirizzoUtente: this.userInfo.indirizzoUtente,
      telefono1Utente: this.userInfo.telefono1Utente,
      telefono2Utente: this.userInfo.telefono2Utente,
      cod: this.userInfo.cod,
      dataNascita: this.userInfo.dataNascita,
      luogoNascita: this.userInfo.luogoNascita,
      emailUtente: this.userInfo.emailUtente,
      pecUtente: this.userInfo.pecUtente,
      comuneUtente: this.userInfo.comuneUtente,
      provinciaUtente: this.userInfo.provinciaUtente,
      entità: this.userInfo.entità,
      codEntità: this.userInfo.codEntità,
      idCap: this.userInfo.idCap,
      idUtente: this.userInfo.idUtente,
      cap: this.userInfo.cap,
      username: this.userInfo.username
    };
    this.ruolo = [];
  }

  created() {
    this.isComplete = userUtils.checkUserInfo(this.userData);
      if (this.checkComplete !== undefined && this.checkComplete === true) {
        if (this.isComplete === false && (!this.userData.ruoloUtente.includes(7) && !this.userData.ruoloUtente.includes(9))) {
          bus.$emit("incompleteInfo");
        }
      }

    bus.$on("editedUser", () => {
      this.userData = user.readUserInfo(this["$store"]);
    });
  }

    mounted() {
    var userInfo: UserInfo = user.readUserInfo(this["$store"]);
    this.ruolo = userInfo.ruoloUtente;
  }
}
